module.exports = __webpack_public_path__ + "img/grenada.b6b7ce3b.png";